import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPatientPrescriptions(patientId) {
    return useQuery(['patientPrescriptions', patientId], () => PESService.getPrescriptions(patientId), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchPatientPrescriptions;
